import { useCallback, useEffect, useRef, useState } from "react";
import { useAuth } from "../../components/context/Auth";
import SlidingFilter2 from "../../components/updatedComponents/Dealers/SlidingFilter2";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import styles from "./Invoice.module.css";
import InputTypedate from "../../components/updatedComponents/FormComponents/InputTypedate";
import Button from "../../components/updatedComponents/Dealers/Button";
import Pagination2 from "../../components/updatedComponents/FormComponents/Pagination2";
import DealerStatusCard from "../../components/updatedComponents/Dealers/DealerStatusCard";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
import { Shareinvoice } from "../../components/icons/Icon4";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import { Refresh, TemplateNotFound } from "../../components/icons/Icon2";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import CheckBox from "../../components/updatedComponents/FormComponents/CheckBox";
import fetchData from "../../APIsControll/apiControll";
import { useNavigate } from "react-router-dom";
import { socket, SocketConnected } from "../../Socket/socket";
import useDebounce from "../../hooks/useDebounce";
import { getMinDate, getStatusColor } from "../../Utils/Utils";
import { daysData, invoiceDashboardHeader, invoiceFilterData } from "../../constants/constants";
import useTableHeight from "../../hooks/useTableHeight";
import { useDispatch, useSelector } from "react-redux";
import {
  resetAllFilters, setClickRow,
  setDaysTab, setKeyword, setStatus
} from "../../store/slices/invoices/InvoicesSlice";

const Invoices = () => {
  const { mode, managerId, designation } = useAuth();
  const { keyword, status, daysTab, clickRow } = useSelector((state) => state.invoices);
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const limit = useTableHeight(tableRef);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  // const [daysTab, setDaysTab] = useState("today");
  // const [status, setStatus] = useState("All");
  // const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [orderManagers, setOrderManagers] = useState([]);
  const [dispatchManagers, setDispatchManagers] = useState([]);

  const [, setSelectedOM] = useState({});
  const [, setSelectedDM] = useState({});

  const debouncedKeyword = useDebounce(keyword, 700);

  const minDate = getMinDate();



  const getAllInvoices = useCallback(async () => {
    if (daysTab === "period" && (startDate === "" || endDate === "")) return;

    const apiData = {
      managerId: managerId,
      keyword: debouncedKeyword,
      day: daysTab === "period" ? "" : daysTab,
      endDate: endDate,
      startDate: startDate,
      // sortKey,            
      // warehousename,           
      // searchBy: selectedRadio.value,
      // paymentMethod: shipingTab.value,  
      // ordermanagerId: selectedManagerID,    
      invoiceStatus: status,
    };
    try {
      setLoading(true);
      const result = await fetchData(
        `invoice/allInvoices?page=${page}&limit=${limit}`,
        apiData
      );

      if (result.status === "success") {
        setData(result.data || []);
        setPages(result.pages || 1);
        setStatusData(Array.isArray(result.orders) ? result.orders : []);
        setOrderManagers(
          result.managers.ordermanagers.map((m) => ({
            label: m.name,
            value: m.managerId,
          }))
        );
        setDispatchManagers(
          result.managers.dispatchmanagers.map((m) => ({
            label: m.name,
            value: m.managerId,
          }))
        );
      }
      if (result.status === "failed") {
        setData([]);
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  }, [
    daysTab,
    debouncedKeyword,
    endDate,
    limit,
    managerId,
    page,
    startDate,
    status,
  ]);

  useEffect(() => {
    if (managerId && limit !== 1) {
      getAllInvoices();
    }
  }, [
    daysTab,
    endDate,
    debouncedKeyword,
    managerId,
    page,
    startDate,
    status,
    limit,
    getAllInvoices,
  ]);

  useEffect(() => {
    SocketConnected({
      socketUserId: `${managerId}`,
      role: designation,
      warehouseNames: JSON.parse(localStorage.getItem("warehouse")),
    });
    socket.on("orderInvoiceStatus", (orderInvoiceStatus) => {
      setData((prev) => {
        const newData = Array.isArray(orderInvoiceStatus)
          ? orderInvoiceStatus
          : [orderInvoiceStatus];
        return [...newData, ...prev];
      });
    });

    return () => {
      socket.disconnect();
    };
  }, [designation, managerId]);

  const daysTabChange = (label) => {
    const selectedFilter = daysData.find((item) => item.label === label);
    const newDayTab = selectedFilter?.value || "today";

    dispatch(setDaysTab(newDayTab));

    if (newDayTab !== "period") {
      setPages([]);
      setStartDate("");
      setEndDate("");
      setPage(1);
    }
  };

  const handleCheck = (orderId) => {
    setSelectedRows((prev) =>
      prev.includes(orderId)
        ? prev.filter((id) => id !== orderId)
        : [...prev, orderId]
    );
  };

  const handleCheckAll = () => {
    if (selectedRows.length === data.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(data.map((r) => r.orderId));
    }
  };

  const allStatus = Array.isArray(statusData)
    ? invoiceFilterData.map((option, index) => ({
      ...option,
      count: statusData[index]?.count || 0,
    })) : [];

  return (
    <div
      className={styles.inv}
      style={mode ? { backgroundColor: "#2C2E33", borderColor: "#2C2E33" } : {}}
    >
      <div className={styles.inv_top}>
        <div className={styles.inv_top_left}>
          <TopTabBar truncate={false} text={"Invoices"} />
        </div>
        <div className={styles.inv_top_right}>
          <div>
            <Button
              buttonBgColor={"#000000"}
              buttonText={"Reset"}
              buttonIcon={<Refresh />}
              buttonTextColor={"#fff"}
              buttonClick={() => dispatch(resetAllFilters())}
            />
          </div>
          <SlidingFilter2
            itemList={daysData.map((item) => item.label)}
            setFilter={daysTabChange}
            selectedItem={
              daysData.find((item) => item.value === daysTab)?.label
            }
          />
          {daysTab === "period" && (
            <>
              <InputTypedate
                text={"From"}
                value={startDate}
                max={endDate}
                min={minDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                  if (daysTab !== "period") {
                    dispatch(setDaysTab(""));
                  }
                  dispatch(setStatus(""));
                }}
              />
              {startDate !== "" && (
                <InputTypedate
                  text={"To"}
                  value={endDate}
                  min={startDate}
                  onChange={(e) => {
                    setEndDate(e.target.value);
                    if (daysTab !== "period") {
                      dispatch(setDaysTab(""));
                    }
                    dispatch(setStatus(""));
                  }}
                />
              )}
            </>
          )}

          <Pagination2
            mode={mode}
            currentPage={page}
            setCurrentPage={setPage}
            totalPages={pages}
          />
        </div>
      </div>

      <div>
        <div
          className={styles.filters}
          style={
            mode ? { borderColor: "#232529", backgroundColor: "#232529" } : {}
          }
        >
          <>
            {allStatus?.map((s) => (
              <div
                key={s.status}
                className={`${styles.filter} ${mode ? styles.filter_dark : ""
                  } ${s.status === status
                    ? mode
                      ? styles.filter_active_dark
                      : styles.filter_active
                    : ""
                  }`}
                onClick={() => {
                  dispatch(setStatus(s.status));
                  setPage(1);
                }}
              >
                <DealerStatusCard
                  statusText={s.label}
                  statusItemCount={s.count}
                />
              </div>
            ))}
          </>
        </div>
      </div>

      <div className={styles.rem_filters}>
        <div className={styles.rem_filters_left}>
          <SearchBar
            padding={"6px"}
            fontSize={"12px"}
            fontWeight={"400"}
            borderRadius={"5px"}
            placeholder={"Dealer ID / Order ID"}
            value={keyword}
            onChange={(e) => {
              dispatch(setKeyword(e.target.value));
              setPage(1);
            }}
          />
        </div>
        <div className={styles.rem_filters_right}>
          <DropDown
            label={"Order Manager"}
            listLabel={"All"}
            options={orderManagers}
            onSelect={(v) => setSelectedOM(v)}
            onReject={() => setSelectedOM({})}
          />
          <DropDown
            label={"Dispatch Manager"}
            listLabel={"All"}
            options={dispatchManagers}
            onSelect={(v) => setSelectedDM(v)}
            onReject={() => setSelectedDM()}
          />
          <Button
            buttonText={"Send Data"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            buttonIcon={<Shareinvoice />}
          />
        </div>
      </div>

      <ul className={styles.data} ref={tableRef}>
        <li
          className={`${styles.data_header} ${mode ? styles.data_header_dark : ""
            }`}
        >
          {invoiceDashboardHeader.map((h, index) =>
            h === "check" ? (
              <span className={styles.entry} key={1}>
                <CheckBox
                  checked={
                    selectedRows.length === data.length && data.length !== 0
                  }
                  handleChange={handleCheckAll}
                />
              </span>
            ) : (
              <div className={styles.entry} key={`${h}-${index}`} title={h}>
                {h}
              </div>
            )
          )}
        </li>

        <div className={styles.data_list}>
          {loading ? (
            <div>
              <Skeleton
                lines={15}
                thickness={5}
                additionalStyles={{ marginBottom: "0px", marginTop: "0px" }}
              />
            </div>
          ) : (
            <>
              {!loading && data.length === 0 ? (
                <>
                  <div className={styles.no_data}>
                    <NoDataFound
                      icon={<TemplateNotFound />}
                      textTitle={`No Data Found`}
                    />
                  </div>
                </>
              ) : (
                <>
                  {data.map((r, index) => (
                    <li
                      key={`Data${index}${r.orderId}`}
                      className={`${styles.data_row} ${mode ? styles.data_row_dark : ""
                        }`}
                      onClick={() => {
                        navigate("/invoices/invoice?orderId=" + r.orderId);
                        dispatch(setClickRow(r.orderId))
                      }}
                      style={{ border: clickRow === r.orderId ? "1px solid #4164E3" : "none" }}
                    >
                      <div
                        className={styles.entry}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <CheckBox
                          checked={selectedRows.includes(r.orderId)}
                          handleChange={() => handleCheck(r.orderId)}
                        />
                      </div>
                      <div className={styles.entry} title={r.orderDate}>
                        {r.orderDate}
                      </div>
                      <div className={styles.entry} title={r.orderId}>
                        {r.orderId}
                      </div>
                      <div
                        className={styles.entry}
                        title={r.storeName + ", " + r.city + ", " + r.dealerId}
                      >
                        {r.storeName + ", " + r.city + ", " + r.dealerId}
                      </div>
                      <div className={styles.entry} title={r.totalAmount}>
                        {r.totalAmount}
                      </div>
                      <div
                        className={styles.entry}
                        style={{ color: getStatusColor(r.status) }}
                        title={r.status}
                      >
                        {r.status}
                      </div>
                      <div
                        className={styles.entry}
                        style={{ color: getStatusColor(r.invoiceStatus) }}
                        title={r.invoiceStatus}
                      >
                        {r.invoiceStatus}
                      </div>
                      <div className={styles.entry} title={r.lastAction}>
                        {r.lastAction}
                      </div>
                    </li>
                  ))}
                </>
              )}
            </>
          )}
        </div>
      </ul>
    </div>
  );
};

export default Invoices;

// const allStatus = [
//   {
//     status: "All",
//     label: "All",
//     count: statusData[0]?.count || 0,
//   },
//   // {
//   //   status: "Cancelled",
//   //   label: "Cancelled",
//   //   count: statusData[1]?.count || 0,
//   // },
//   {
//     status: "Pending",
//     label: "Pending",
//     count: statusData[2]?.count || 0,
//   },
//   {
//     status: "Urgent",
//     label: "Urgent",
//     count: statusData[6]?.count || 0,
//   },
//   {
//     status: "Completed",
//     label: "Completed",
//     count: statusData[3]?.count || 0,
//   },
//   // {
//   //   status: "Reupload",
//   //   label: "Re Upload",
//   //   count: statusData[4]?.count || 0,
//   // },
//   // {
//   //   status: "OrderReturn",
//   //   label: "Order Return",
//   //   count: statusData[5]?.count || 0,
//   // },
// ];
